import { Component, OnInit } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { CookingStoryGroceryService } from 'src/app/data/repository/cooking-story/cooking-story-grocery.service';
import { AppCookingStoryPopupComponent } from './app-cooking-story-popup/app-cooking-story-popup.component';

@Component({
  selector: 'app-cooking-story-success-message',
  templateUrl: './cooking-story-success-message.component.html',
  styleUrls: ['./cooking-story-success-message.component.scss'],
})
export class CookingStorySuccessMessageComponent implements OnInit {
  constructor(
    private matBottomSheet: MatBottomSheet,
    private cookingStoryGroceryService: CookingStoryGroceryService
  ) {}

  ngOnInit(): void {
    this.cookingStoryGroceryService.openPopUp.subscribe((data) => {
      if (data) {
        this.open(data);
      }
    });
  }
  open(message: string) {
    this.matBottomSheet.open(AppCookingStoryPopupComponent, {
      panelClass: 'custom-bottomsheet-container',
      data: { message },
    });
  }
}
